import api from 'services/api';

const normalizeSinalRows = (payload) => {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (payload && typeof payload === 'object') {
    if (Array.isArray(payload.sinal_ctos)) {
      return payload.sinal_ctos;
    }

    if (Array.isArray(payload.rows)) {
      return payload.rows;
    }
  }

  return [];
};

const normalizeQtdCabo = (payload) => {
  if (payload && typeof payload === 'object') {
    if (payload.qtd_cabo && typeof payload.qtd_cabo === 'object' && !Array.isArray(payload.qtd_cabo)) {
      return payload.qtd_cabo;
    }

    if (typeof payload.quantidade_cabo !== 'undefined') {
      return payload;
    }
  }

  return {
    quantidade_cabo: 0,
    por_projeto: [],
  };
};

class SinalCtoService {
  async buscarSinalCtos(signal = null) {
    const config = signal ? { signal } : {};
    const response = await api.get('/infraestrutura/sinal/ctos', config);

    return {
      data: {
        sinal_ctos: normalizeSinalRows(
          response.data?.data?.sinal_ctos
          ?? response.data?.sinal_ctos
          ?? response.data?.data
          ?? response.data,
        ),
      },
    };
  }

  async buscarQtdCabo(signal = null) {
    const config = signal ? { signal } : {};
    const response = await api.get('/infraestrutura/sinal/qtd-cabo', config);

    return {
      data: {
        qtd_cabo: normalizeQtdCabo(
          response.data?.data?.qtd_cabo
          ?? response.data?.qtd_cabo
          ?? response.data?.data
          ?? response.data,
        ),
      },
    };
  }
}

const sinalCtoService = new SinalCtoService();

export default sinalCtoService;
